<div class="container grid content-center justify-center">
    <div class="py-4">
        <img alt="error" height="48" ngSrc="/assets/icons/error-svgrepo-com.svg" width="48" />
    </div>

    <p class="text-2xl font-bold">This page isn't working</p>

    <p class="mb-5 text-sm text-gray-500">If the problem continues, contact the site owner</p>

    <p class="text-sm text-gray-500">HTTP Error 401</p>

    <button (click)="onBack()" class="w-full mt-10" mat-flat-button type="button">Go Back</button>
</div>
